<nz-layout>
  <nz-header
    style="
      position: fixed;
      width: 100%;
      box-shadow: #ccc 0 0 10px;
      background-color: #fff;
      z-index: 10;
    "
  >
    <div nz-row style="position: absolute; top: 0; left: 10px">
      <div nz-col [nzSpan]="24" [nzXXl]="0">
        <button
          nz-button
          nzType="text"
          (click)="
            isMenuDrawerVisible
              ? (isMenuDrawerVisible = false)
              : (isMenuDrawerVisible = true)
          "
        >
          <span nz-icon nzType="menu" nzTheme="outline"></span>
        </button>
      </div>
    </div>
    <a href="/" routerLink="/">
      <img src="/assets/logos/main-logo.webp" width="42" />
      <span
        style="
          font-size: 18px;
          margin-left: 10px;
          font-weight: bold;
          color: #000;
        "
        >CICCA</span
      >
    </a>
    <span style="float: right">
      <a nzTrigger="click">
        <div nz-row>
          <nz-col [nzSpan]="24" [nzSm]="24" [nzXs]="0">
            <strong style="text-transform: capitalize"
              >សួរស្ដី! {{ profile.name }}</strong
            >
            <nz-avatar
              nzSrc=""
              nzIcon="user"
              style="margin-left: 10px"
            ></nz-avatar>
          </nz-col>
          <nz-col [nzSpan]="0" [nzSm]="0" [nzXs]="24">
            <strong style="text-transform: capitalize"
              >សួរស្ដី!
              {{
                profile.name.length > 4
                  ? profile.name.slice(0, 4) + "..."
                  : profile.name
              }}</strong
            >
            <nz-avatar
              nzSrc=""
              nzIcon="user"
              style="margin-left: 10px"
            ></nz-avatar>
          </nz-col>
        </div>
      </a>
    </span>
  </nz-header>
  <nz-layout>
    <div nz-row style="padding-top: 64px">
      <div nz-col [nzSpan]="0" [nzXXl]="3" [nzXl]="0" [nzLg]="0">
        <!-- <nz-sider style="background: none">
          <div class="sider">
            <ng-container [ngTemplateOutlet]="siderMenuTpl"></ng-container>
          </div>
        </nz-sider> -->
        <nz-sider>
          <ul nz-menu nzMode="inline" style="height: 100%; padding-top: 16px">
            <li
              nz-menu-item
              *ngFor="let item of menuItems"
              [routerLink]="item.to"
              [nzDisabled]="item.disabled"
            >
              <span nz-icon [nzType]="item.icon" style="margin: 0 10px"></span>
              {{ item.name }}
            </li>

            <ng-container *ngIf="profile.role.code === 'su'">
              <li nz-menu-divider></li>
              <li
                nz-menu-item
                *ngFor="let item of superAdminMenuItems"
                [routerLink]="item.to"
                [nzDisabled]="item.disabled"
              >
                <span
                  nz-icon
                  [nzType]="item.icon"
                  style="margin-right: 10px"
                ></span>
                {{ item.name }}
              </li>
            </ng-container>

            <li nz-menu-divider></li>
            <li nz-menu-item (click)="openHelp()">
              <span
                nz-icon
                (click)="isMenuDrawerVisible = false"
                nzType="info-circle"
                nzTheme="outline"
              ></span>
              <span>ជំនួយបន្ទាន់</span>
            </li>
            <li nz-menu-item (click)="logoutClicked()">
              <span nz-icon nzType="logout" nzTheme="outline"></span>
              <span>ចាកចេញ</span>
            </li>
          </ul>
        </nz-sider>
      </div>
      <div
        nz-col
        [nzSpan]="0"
        [nzXXl]="21"
        [nzXl]="24"
        [nzLg]="24"
        [nzMd]="24"
        [nzSm]="24"
        [nzXs]="24"
      >
        <nz-layout class="inner-layout">
          <nz-content>
            <ng-content></ng-content>
          </nz-content>
          <nz-footer style="padding: 20px;">
            <div nz-row >
              <div nz-col [nzSpan]="12" [nzSm]="6" [nzXs]="0">
                &copy; 2023,CICCA
              </div>
              <div
                nz-col
                [nzSpan]="0"
                [nzSm]="18"
                [nzXs]="0"
                style="text-align: right"
              >
                <ng-container [ngTemplateOutlet]="btnTpl"></ng-container>
              </div>
              <div
                nz-col
                [nzSpan]="0"
                [nzSm]="0"
                [nzXs]="24"
                style="text-align: center"
              >
                <ng-container [ngTemplateOutlet]="btnTpl"></ng-container>
              </div>
              <ng-template #btnTpl>
                <button
                  nz-button
                  nzType="text"
                  routerLink="https://www.youtube.com/@cicca_org_kh"
                  target="_blank"
                >
                  Youtube
                </button>
                <button
                  nz-button
                  nzType="text"
                  routerLink="https://www.cicca.org.kh"
                  target="_blank"
                >
                  Website
                </button>
                <button
                  nz-button
                  nzType="text"
                  routerLink="https://www.facebook.com/cicca.org.kh"
                  target="_blank"
                >
                  Facebook
                </button>
                <button
                  nz-button
                  nzType="text"
                  routerLink="https://t.me/cicca_org_kh"
                >
                  Telegram
                </button>
              </ng-template>
            </div>
          </nz-footer>
        </nz-layout>
      </div>
    </div>
  </nz-layout>
</nz-layout>
<!-- <ng-template #siderMenuTpl>
  <ul nz-menu nzMode="inline" style="background: none">
    <li>
      <ul>
        <li nz-menu-group>
          <ul class="menu">
            <li
              nz-menu-item
              style="
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
              "
              routerLink="/"
            >
              <span nz-icon nzType="home" style="margin-right: 10px"></span>
              ទំព័រដើម
              <span style="flex: 1 1 auto"></span>
            </li>
            <li nz-menu-item routerLink="/profile/about">
              <span nz-icon style="margin-right: 10px">o</span>
              អំពីអ្នក
            </li>
            <li nz-menu-item routerLink="/account/setting">
              <span nz-icon style="margin-right: 10px">o</span>
              គ្រប់គ្រង់គណនី
            </li>
            <li nz-menu-item routerLink="/account/point">
              <span nz-icon style="margin-right: 10px">o</span>
              ពិន្ទុ
            </li>
            <li
              nz-menu-item
              style="
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              "
              nzDisabled
            >
              <span nz-icon style="margin-right: 10px">o</span>
              វិញ្ញាបនប័ត្រ
            </li>
          </ul>
        </li>
      </ul>
      <ul
        *ngIf="profile.role.code === 'su'"
        class="menu"
        style="margin-top: 25px"
      >
        <li
          nz-menu-item
          routerLink="/admin/users"
          style="border-top-left-radius: 10px; border-top-right-radius: 10px"
        >
          <span nz-icon style="margin-right: 10px">o</span>
          សមាជិកសមាគម
        </li>
        <li
          nz-menu-item
          routerLink="/admin/request"
          style="
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          "
        >
          <span nz-icon style="margin-right: 10px">o</span>
          ស្នើសុំចូលសមាជិក
        </li>
        <li
          nz-menu-item
          (click)="isMenuDrawerVisible = false"
          routerLink="/admin/organization"
          *ngIf="profile.role.code === 'su'"
        >
          <span style="margin-right: 15px">o</span>
          <span>អង្គភាព</span>
        </li>
        <li
          nz-menu-item
          (click)="isMenuDrawerVisible = false"
          routerLink="/admin/campaign"
          *ngIf="profile.role.code === 'su'"
        >
          <span style="margin-right: 15px">o</span>
          <span>សកម្មភាពមនុស្សធម៌</span>
        </li>
      </ul>
      <ul>
        <li nz-menu-group>
          <ul class="menu">
            <li
              nz-menu-item
              style="
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
              "
              (click)="openHelp()"
            >
              <span
                nz-icon
                nzType="info-circle"
                style="margin-right: 10px"
              ></span>
              ជំនួយបន្ទាន់
            </li>
            <li
              nz-menu-item
              style="
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              "
              (click)="logoutClicked()"
            >
              <span
                nz-icon
                nzType="logout"
                nzTheme="outline"
                style="margin-right: 10px"
              ></span>
              ចាកចេញ
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <div style="display: block; height: 25px"></div>
</ng-template> -->

<nz-drawer
  [nzVisible]="isMenuDrawerVisible"
  nzPlacement="left"
  [nzMaskClosable]="true"
  [nzClosable]="false"
  (nzOnClose)="isMenuDrawerVisible = false"
  [nzBodyStyle]="{ padding: 0 }"
  [nzWidth]="250"
>
  <ng-container *nzDrawerContent>
    <div style="padding: 10px 20px">
      <img src="/assets/logos/main-logo.webp" width="42" />
      <span
        style="
          font-size: 18px;
          margin-left: 10px;
          font-weight: bold;
          color: #000;
        "
        >CICCA</span
      >
    </div>
  <ul nz-menu nzMode="inline" style="height: 100%; padding-top: 16px">
            <li
              nz-menu-item
              *ngFor="let item of menuItems"
              [routerLink]="item.to"
              [nzDisabled]="item.disabled"
            >
              <span nz-icon [nzType]="item.icon" style="margin: 0 10px"></span>
              {{ item.name }}
            </li>

            <ng-container *ngIf="profile.role.code === 'su'">
              <li nz-menu-divider></li>
              <li
                nz-menu-item
                *ngFor="let item of superAdminMenuItems"
                [routerLink]="item.to"
                [nzDisabled]="item.disabled"
              >
                <span
                  nz-icon
                  [nzType]="item.icon"
                  style="margin-right: 10px"
                ></span>
                {{ item.name }}
              </li>
            </ng-container>

            <li nz-menu-divider></li>
            <li nz-menu-item (click)="openHelp()">
              <span
                nz-icon
                (click)="isMenuDrawerVisible = false"
                nzType="info-circle"
                nzTheme="outline"
              ></span>
              <span>ជំនួយបន្ទាន់</span>
            </li>
            <li nz-menu-item (click)="logoutClicked()">
              <span nz-icon nzType="logout" nzTheme="outline"></span>
              <span>ចាកចេញ</span>
            </li>
          </ul>
  </ng-container>
</nz-drawer>
